
import { Vue, Component, Prop } from 'vue-property-decorator'
import { getAbbreviation } from '@/utils/project'
import { getPreview } from '@/utils/attachment'

@Component
export default class ProjectAvatar extends Vue {
    @Prop({ required: true }) item!: Record<string, any>

    error = false

    get abbreviation() {
        return getAbbreviation(this.item.name)
    }

    get url() {
        if (this.item?.avatarFileId) {
            return `${getPreview(this.item.avatarFileId)}?maxImgWidth=80&maxWaitSeconds=20`
        }
        return null
    }
}
